import { render } from "./PremiumServices.vue?vue&type=template&id=063c7b69&scoped=true"
import script from "./PremiumServices.vue?vue&type=script&lang=js"
export * from "./PremiumServices.vue?vue&type=script&lang=js"

import "./PremiumServices.vue?vue&type=style&index=0&id=063c7b69&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-063c7b69"]])

export default __exports__